/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var KonturInstallIcon16Regular = forwardRef('KonturInstallIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M9.208 8.324A1.251 1.251 0 0 0 8 6.75a1.25 1.25 0 1 0 .324 2.458l1.984 1.984a.625.625 0 1 0 .884-.884L9.208 8.324Z" }),
        React.createElement("path", { d: "M7.732 5.012a.5.5 0 0 1-.09-.996 4.047 4.047 0 0 1 3.267 1.238 4.047 4.047 0 0 1 1.048 3.333.5.5 0 0 1-.99-.147 3.035 3.035 0 0 0-.785-2.5 3.035 3.035 0 0 0-2.45-.928Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 1a7 7 0 1 0 0 14A7 7 0 0 0 8 1ZM2.5 8a5.5 5.5 0 1 1 11 0 5.5 5.5 0 0 1-11 0Z" })));
});
